module.exports = __webpack_public_path__ + "static/media/azure-active-directory.c138cd01.png";